/* ---- helper to ensure/patch meta tags ---- */
const setOrCreateMeta = (name, content, attrs = {}) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

export { setOrCreateMeta };
